import { LocationIp } from "./types"
import { getLargestCitiesOfRussia, ALL_RUSSIA } from "@components/header/GeoMenu/initCityData"

// Города, где на сайте есть события (тот же список, что в выборе города)
const KNOWN = getLargestCitiesOfRussia(ALL_RUSSIA).filter(c => c.city !== "Вся Россия")
const MOSCOW = KNOWN.find(c => c.city === "Москва")!

const toLocation = (c: typeof MOSCOW): LocationIp => ({
  city: c.city, region: c.region, country: "Российская Федерация",
  latitude: Number(c.latitude), longitude: Number(c.longitude), source: "ip",
})

/**
 * IP мобильного интернета часто указывает не на реальный город, а на узел оператора
 * (Люберцы, Одинцово, другой регион). Такой город ломает ленту — событий там нет.
 * Приводим результат к городу из нашего списка:
 *  - город из списка — оставляем;
 *  - Москва и Подмосковье — Москва;
 *  - город в области, где у нас есть областной центр, — этот центр;
 *  - всё остальное — Москва (основная аудитория).
 */
export const normalizeIpCity = (loc: { city?: string; region?: string }): LocationIp => {
  const city = (loc.city || "").trim().toLowerCase()
  const region = (loc.region || "").trim().toLowerCase()
  const byCity = KNOWN.find(c => c.city.toLowerCase() === city)
  if (byCity) return toLocation(byCity)
  if (region.includes("моск") || city.includes("моск") || city === "moscow") return toLocation(MOSCOW)
  const byRegion = region && KNOWN.find(c => c.region.toLowerCase() === region)
  if (byRegion) return toLocation(byRegion)
  return toLocation(MOSCOW)
}

export const isKnownCity = (city?: string) => !!city && (city === "Вся Россия" || KNOWN.some(c => c.city === city))
